import c0 from './accordion_component_controller';
import c1 from './alert_bar_controller';
import c2 from './audio_player_component_controller';
import c3 from './button_component_controller';
import c4 from './drawer_controller';
import c5 from './dropdown_controller';
import c6 from './feature_callout_component_controller';
import c7 from './filters/date_range_component_controller';
import c8 from './forms/timestamp_component_controller';
import c9 from './media/audio_player_controller';
import c10 from './media/video_player_controller';
import c11 from './modal_component_controller';
import c12 from './offer_component_controller';
import c13 from './patreon_offer_component_controller';
import c14 from './price_component_controller';
import c15 from './qr_code_controller';
import c16 from './stats_component_controller';
import c17 from './targeting_component_controller';
import c18 from './tus_upload_component_controller';
import c19 from './typeahead_component_controller';
import c20 from './ui/table_component_controller';
import c21 from './ui/table_component_filter_controller';
export const definitions = [
	{identifier: 'accordion-component', controllerConstructor: c0},
	{identifier: 'alert-bar', controllerConstructor: c1},
	{identifier: 'audio-player-component', controllerConstructor: c2},
	{identifier: 'button-component', controllerConstructor: c3},
	{identifier: 'drawer', controllerConstructor: c4},
	{identifier: 'dropdown', controllerConstructor: c5},
	{identifier: 'feature-callout-component', controllerConstructor: c6},
	{identifier: 'filters--date-range-component', controllerConstructor: c7},
	{identifier: 'forms--timestamp-component', controllerConstructor: c8},
	{identifier: 'media--audio-player', controllerConstructor: c9},
	{identifier: 'media--video-player', controllerConstructor: c10},
	{identifier: 'modal-component', controllerConstructor: c11},
	{identifier: 'offer-component', controllerConstructor: c12},
	{identifier: 'patreon-offer-component', controllerConstructor: c13},
	{identifier: 'price-component', controllerConstructor: c14},
	{identifier: 'qr-code', controllerConstructor: c15},
	{identifier: 'stats-component', controllerConstructor: c16},
	{identifier: 'targeting-component', controllerConstructor: c17},
	{identifier: 'tus-upload-component', controllerConstructor: c18},
	{identifier: 'typeahead-component', controllerConstructor: c19},
	{identifier: 'ui--table-component', controllerConstructor: c20},
	{identifier: 'ui--table-component-filter', controllerConstructor: c21},
];
